// assets/services.js
// FHL GO — Services page behaviour (i18n + reveal + anchor offset)

(function () {
  console.log("[services.js] loaded");

  /* ===================== I18N TEXT ===================== */

  const I18N = {
    en: {
      toggleLabel: "EN | ES",
      crumbHome: "Home",
      services: "Services",
      crumbServices: "Services",

      heroTitle: "Ship smart. Stay informed. Delivered with care.",
      heroSub:
        "From Miami to Peru, Venezuela, and Costa Rica—our network moves your documents and parcels with speed, clear communication, and human support.",
      ctaStart: "Start a Shipment",
      ctaExplore: "Explore Services",

      qlCourier: "Courier Service",
      qlParcel: "Parcel Service",
      qlUpdates: "Shipment Updates & Support",
      qlWarehouse: "Miami Warehouse",

      courierTitle: "Courier Service",
      courierBody1:
        "Documents need to move fast and arrive intact. Our courier option gives you a clear, easy-to-understand rate for document shipments with local and international delivery.",
      courierLi1:
        "Straightforward pricing for document shipments—no surprises.",
      courierLi2:
        "Local handoffs with trained staff at our partner offices.",
      courierLi3: "Priority routes to Peru, Venezuela, and Costa Rica.",

      tileSpeed: "Speed",
      tileSpeedBody: "Priority handling from first scan to final handoff.",
      tileSecurity: "Security",
      tileSecurityBody:
        "Sealed handling and ID-verified delivery at destination.",
      tileSupport: "Support",
      tileSupportBody:
        "Real humans to help when something needs attention.",

      parcelTitle: "Parcel Service",
      parcelBody1:
        "When speed, security, and care are non-negotiable, our parcel service operates at a premium standard. We treat every box like it’s headed to someone important—because it is.",
      parcelLi1: "Careful handling across borders with reliable carriers.",
      parcelLi2:
        "Clear pricing that reflects the service level you choose.",
      parcelLi3: "Door-to-door options in most metro areas.",

      tileSpecialized: "Specialized",
      tileSpecializedBody:
        "Options for fragile, time-sensitive, or high-value items.",
      tileReliable: "Reliable",
      tileReliableBody: "Consistent delivery windows using trusted partners.",
      tileTransparent: "Transparent",
      tileTransparentBody:
        "Up-front quotes—no mystery fees or surprise add-ons.",

      updatesTitle: "Shipment Updates & Support",
      updatesBody1:
        "Stay informed as your shipment moves through our network. We prioritize clear communication, so you know what stage your shipment is in and who to contact if something changes.",
      updatesLi1:
        "Status milestones shared at key points in the journey.",
      updatesLi2:
        "Simple references so our team can quickly find your shipment.",
      updatesLi3:
        "Live support via chat or phone when you need extra help.",

      whTitle: "Miami Warehouse & Consolidation",
      whBody1:
        "Our Miami warehouse is the hub that keeps everything moving smoothly. We receive, check, and prepare your items before they head to Peru, Venezuela, or Costa Rica.",
      whLi1:
        "Receiving from US retailers and carriers at a single Miami address.",
      whLi2:
        "Consolidation options to optimize space and reduce overall costs.",
      whLi3: "Export lanes tuned for our Latin American destinations.",

      procTitle: "How it works",
      s1: "1) Create your shipment",
      s1b:
        "Tell us what you’re sending and where it’s going for an instant quote.",
      s2: "2) Drop off or schedule pickup",
      s2b:
        "Bring it to our Miami address or work with our team for pickup options.",
      s3: "3) In transit",
      s3b:
        "We move your shipment through our network and keep you informed along the way.",
      s4: "4) Delivered",
      s4b: "Door-to-door service is available in most metro areas.",

      ctaQuote: "Get a Quote",
      ctaAbout: "About FHL GO",

      followTitle: "FOLLOW US ON",
      companyTitle: "COMPANY",
      legalTitle: "LEGAL INFO",
      lnkAbout: "About Us",
      lnkServices: "Services",
      lnkBlog: "Blog",
      lnkTerms: "Terms of Service",
      lnkPrivacy: "Privacy Policy",
      lnkRefunds: "Refund Policy",
      copyright:
        "© 2025 FHL GO. Powered by Shopify — Developed by DIGIFUZEFX",
    },

    es: {
      toggleLabel: "ES | EN",
      crumbHome: "Inicio",
      services: "Servicios",
      crumbServices: "Servicios",

      heroTitle:
        "Envía inteligente. Mantente informado. Entrega con cuidado.",
      heroSub:
        "Desde Miami hacia Perú, Venezuela y Costa Rica—nuestra red mueve tus documentos y paquetes con rapidez, comunicación clara y apoyo humano.",
      ctaStart: "Crear un envío",
      ctaExplore: "Ver servicios",

      qlCourier: "Servicio de Courier",
      qlParcel: "Servicio de Paquetería",
      qlUpdates: "Actualizaciones y Soporte",
      qlWarehouse: "Almacén en Miami",

      courierTitle: "Servicio de Courier",
      courierBody1:
        "Los documentos deben moverse rápido y llegar intactos. Nuestro courier ofrece una tarifa clara y sencilla para envíos de documentos con entrega local e internacional.",
      courierLi1:
        "Precio claro para envíos de documentos—sin sorpresas.",
      courierLi2:
        "Entregas locales con personal capacitado en oficinas asociadas.",
      courierLi3: "Rutas prioritarias a Perú, Venezuela y Costa Rica.",

      tileSpeed: "Velocidad",
      tileSpeedBody:
        "Manejo prioritario desde el primer escaneo hasta la entrega.",
      tileSecurity: "Seguridad",
      tileSecurityBody:
        "Manejo sellado y entrega verificada con identificación.",
      tileSupport: "Soporte",
      tileSupportBody: "Personas reales para ayudarte cuando hace falta.",

      parcelTitle: "Servicio de Paquetería",
      parcelBody1:
        "Cuando la velocidad, la seguridad y el cuidado no se negocian, nuestro servicio de paquetería opera con estándar premium. Tratamos cada caja como si fuera para alguien importante—porque lo es.",
      parcelLi1:
        "Manejo cuidadoso entre países con carriers de confianza.",
      parcelLi2:
        "Precio claro que refleja el nivel de servicio que eliges.",
      parcelLi3:
        "Opciones puerta a puerta en la mayoría de zonas urbanas.",

      tileSpecialized: "Especializado",
      tileSpecializedBody:
        "Opciones para artículos frágiles, urgentes o de alto valor.",
      tileReliable: "Confiable",
      tileReliableBody:
        "Ventanas de entrega consistentes con socios confiables.",
      tileTransparent: "Transparente",
      tileTransparentBody:
        "Cotización por adelantado—sin cargos ocultos ni sorpresas.",

      updatesTitle: "Actualizaciones de Envío y Soporte",
      updatesBody1:
        "Mantente informado mientras tu envío se mueve en nuestra red. Priorizamos la comunicación clara para que sepas en qué etapa va tu envío y con quién hablar si algo cambia.",
      updatesLi1:
        "Hitos de estado compartidos en momentos clave del recorrido.",
      updatesLi2:
        "Referencias simples para que nuestro equipo ubique tu envío rápido.",
      updatesLi3:
        "Soporte en vivo por chat o teléfono cuando necesitas ayuda extra.",

      whTitle: "Almacén en Miami y Consolidación",
      whBody1:
        "Nuestro almacén en Miami es el centro que mantiene todo fluyendo. Recibimos, revisamos y preparamos tus artículos antes de enviarlos a Perú, Venezuela o Costa Rica.",
      whLi1:
        "Recepción desde comercios y carriers en EE. UU. a una sola dirección en Miami.",
      whLi2:
        "Opciones de consolidación para optimizar espacio y reducir costos.",
      whLi3:
        "Rutas de exportación ajustadas a nuestros destinos en Latinoamérica.",

      procTitle: "Cómo funciona",
      s1: "1) Crea tu envío",
      s1b:
        "Cuéntanos qué envías y a dónde va para obtener una cotización al instante.",
      s2: "2) Entrega o programa recolección",
      s2b:
        "Llévalo a nuestra dirección en Miami o coordina opciones de recolección.",
      s3: "3) En tránsito",
      s3b:
        "Movemos tu envío en nuestra red y te mantenemos informado durante el recorrido.",
      s4: "4) Entregado",
      s4b:
        "Servicio puerta a puerta disponible en la mayoría de zonas urbanas.",

      ctaQuote: "Obtener cotización",
      ctaAbout: "Sobre FHL GO",

      followTitle: "SÍGUENOS",
      companyTitle: "COMPAÑÍA",
      legalTitle: "INFO LEGAL",
      lnkAbout: "Quiénes somos",
      lnkServices: "Servicios",
      lnkBlog: "Blog",
      lnkTerms: "Términos del servicio",
      lnkPrivacy: "Política de privacidad",
      lnkRefunds: "Política de reembolsos",
      copyright:
        "© 2025 FHL GO. Con tecnología de Shopify — Desarrollado por DIGIFUZEFX",
    },
  };

  function applyLang(lang) {
    const dict = I18N[lang] || I18N.en;
    console.log("[services.js] applyLang:", lang);

    // Plain text
    document.querySelectorAll("[data-i18n]").forEach((el) => {
      const key = el.dataset.i18n;
      if (!key) return;
      if (dict[key]) el.textContent = dict[key];
    });

    // HTML-enabled
    document.querySelectorAll("[data-i18n-html]").forEach((el) => {
      const key = el.dataset.i18nHtml;
      if (!key) return;
      if (dict[key]) el.innerHTML = dict[key];
    });

    // Update pill label (try a bunch of possible selectors)
    const toggle =
      document.getElementById("fhlgo-lang-toggle") ||
      document.getElementById("langToggleTop") ||
      document.querySelector(".fhlgo-lang-toggle") ||
      document.querySelector(".lang-toggle") ||
      document.querySelector('[data-i18n="toggleLabel"]');

    if (toggle && dict.toggleLabel) toggle.textContent = dict.toggleLabel;

    // Document title
    document.title =
      lang === "es" ? "FHL GO — Servicios" : "FHL GO — Services";

    // Persist using shared key
    try {
      localStorage.setItem("fhl_lang", lang);
    } catch (e) {}

    // Notify header/logo listeners
    try {
      const ev = new CustomEvent("fhlgo:lang-switch", { detail: { lang } });
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", function () {
    console.log("[services.js] DOMContentLoaded");

    // Initial language (from localStorage)
    const saved = (() => {
      try {
        return localStorage.getItem("fhl_lang") || "en";
      } catch (e) {
        return "en";
      }
    })();
    applyLang(saved);

    // Find the toggle button (very forgiving)
    const toggle =
      document.getElementById("fhlgo-lang-toggle") ||
      document.getElementById("langToggleTop") ||
      document.querySelector(".fhlgo-lang-toggle") ||
      document.querySelector(".lang-toggle") ||
      document.querySelector('[data-i18n="toggleLabel"]');

    if (toggle) {
      console.log("[services.js] toggle found →", toggle);
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        let current = "en";
        try {
          current = localStorage.getItem("fhl_lang") || "en";
        } catch (err) {}
        const next = current === "en" ? "es" : "en";
        console.log("[services.js] toggle click →", next);
        applyLang(next);
      });
    } else {
      console.warn("[services.js] No language toggle found on this page");
    }

    // Also respond if some other script fires fhlgo:lang-switch
    document.addEventListener("fhlgo:lang-switch", function (e) {
      const lang = (e && e.detail && e.detail.lang) || "en";
      console.log("[services.js] external fhlgo:lang-switch →", lang);
      applyLang(lang);
    });

    // Reveal-on-scroll (scoped)
    if (
      !(
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      )
    ) {
      const io = new IntersectionObserver(
        (entries) => {
          for (const ent of entries) {
            if (ent.isIntersecting) {
              ent.target.classList.add("is-visible");
              io.unobserve(ent.target);
            }
          }
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );

      const nodes =
        document.querySelectorAll(".services-page [data-reveal]") ||
        document.querySelectorAll("[data-reveal]");

      nodes.forEach((el) => io.observe(el));
    }

    // Anchor offset under sticky header
    const header =
      document.querySelector(".fhlgo-country-header") ||
      document.querySelector(".site-header");
    const setOffset = () => {
      const h = header ? header.offsetHeight : 96;
      document.documentElement.style.setProperty(
        "--anchor-offset",
        h + 12 + "px"
      );
    };
    setOffset();
    window.addEventListener("resize", setOffset);
    window.addEventListener("load", setOffset);
  });
})();
